import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminBrokers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then(r => setUsers(r.data.filter(u => u.role === "admin_broker" || u.role === "buyer"))); }, []);
  const brokers = users.filter(u => u.role === "admin_broker");
  const buyers = users.filter(u => u.role === "buyer");
  return (
    <div data-testid="admin-brokers-page">
      <h1 className="editorial-heading text-4xl">Broker & Buyer</h1>
      <div className="mt-6 grid md:grid-cols-2 gap-6">
        <div className="bg-card border border-border rounded-sm p-5">
          <div className="text-xs uppercase tracking-[0.2em] font-bold mb-3">Broker ({brokers.length})</div>
          <div className="space-y-2">
            {brokers.map(b => (
              <div key={b.id} className="flex justify-between items-center text-sm border-b border-border pb-2">
                <div><div className="font-semibold">{b.name}</div><div className="text-xs text-muted-foreground">{b.email}</div></div>
                <div className="text-xs text-muted-foreground">{b.company}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-card border border-border rounded-sm p-5">
          <div className="text-xs uppercase tracking-[0.2em] font-bold mb-3">Buyer B2B ({buyers.length})</div>
          <div className="space-y-2">
            {buyers.map(b => (
              <div key={b.id} className="flex justify-between items-center text-sm border-b border-border pb-2">
                <div><div className="font-semibold">{b.name}</div><div className="text-xs text-muted-foreground">{b.email}</div></div>
                <div className="text-xs text-right"><div>{b.company}</div><div className="text-muted-foreground">{b.country} · {b.vat_number || "—"}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
